module.exports = __webpack_public_path__ + "img/Photo_7__Third_Canal_992_17_4.34f9e624.jpg";